<template>
  <div>
    <div>
      <RawJsonToggler :json="workflow" />
      <!-- Workflow -->
      <h1>{{ workflow.workflowName }}</h1>
      <!-- Actions -->
      <Fieldset legend="Actions">
        <button @click="getWorkflow(workflowId)">refresh</button>
        <router-link
          v-if="workflow.parentWorkflowId"
          tag="button"
          :to="{
            name: 'workflow',
            params: { workflowId: workflow.parentWorkflowId }
          }"
        >
          Parent Workflow
        </router-link>
        <router-link
          v-if="workflow.parentWorkflowTaskId"
          tag="button"
          :to="{
            name: 'task',
            params: { taskId: workflow.parentWorkflowTaskId }
          }"
        >
          Parent Workflow Task
        </router-link>
        <div v-if="!readOnly">
          <button @click="decideWorkflow">decide</button>
          <button @click="pauseWorkflow">pause</button>
          <button @click="resumeWorkflow">resume</button>
          <router-link
            tag="button"
            :to="{ name: 'workflowRerun', params: { workflowId: workflowId } }"
          >
            rerun
          </router-link>
          <router-link
            tag="button"
            :to="{
              name: 'workflowSkipTask',
              params: { workflowId: workflowId }
            }"
          >
            skip task
          </router-link>
          <button @click="restartWorkflow">restart</button>
          <button @click="retryWorkflow">retry last task</button>
          <button @click="stopWorkflow">stop</button>
          <button @click="archiveWorkflow">archive</button>
          <button @click="removeWorkflow">remove</button>
        </div>
      </Fieldset>
      <DataList :data="workflow" :attributes="attributes" />
      <!-- Tasks -->
      <DataTable
        caption="Tasks"
        :rowKeys="['taskId']"
        :rows="workflow.tasks"
        :actions="
          readOnly
            ? [
                {
                  name: 'task',
                  label: 'View',
                  params: { taskId: 'taskId' }
                }
              ]
            : [
                {
                  name: 'task',
                  label: 'View',
                  params: { taskId: 'taskId' }
                },
                {
                  name: 'taskResultEdit',
                  label: 'Update',
                  params: { taskId: 'taskId' }
                }
              ]
        "
        :columns="[
          { name: 'seq', type: 'text' },
          { name: 'domain', type: 'text' },
          { name: 'taskType', type: 'text' },
          { name: 'status', type: 'text' },
          { name: 'taskId', type: 'text' },
          { name: 'referenceTaskName', type: 'text' },
          { name: 'scheduledTime', type: 'date' },
          { name: 'pollCount', type: 'text' },
          { name: 'queueWaitTime', type: 'duration' },
          { name: 'startTime', type: 'date' },
          { name: 'updateTime', type: 'date' },
          { name: 'endTime', type: 'date' },
          { name: 'reasonForIncompletion', type: 'text' },
          { name: 'retryCount', type: 'text' },
          { name: 'retriedTaskId', type: 'text' }
        ]"
      />
      <hr />
      <h3>Workflow Definition</h3>
      <EmbedWorkflowDefinition
        :workflowDefinition="workflow.workflowDefinition"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Fieldset from '@/components/Fieldset.vue'
import DataTable from '@/components/DataTable.vue'
import DataList from '@/components/DataList.vue'
import RawJsonToggler from '@/components/RawJsonToggler.vue'
import EmbedWorkflowDefinition from '@/components/EmbedWorkflowDefinition.vue'

export default {
  name: 'Workflow',
  props: ['workflowId'],
  data() {
    return {
      attributes: [
        { name: 'parentWorkflowId', type: 'text' },
        { name: 'parentWorkflowTaskId', type: 'text' },
        { name: 'correlationId', type: 'text' },
        { name: 'workflowId', type: 'text' },
        { name: 'version', type: 'text' },
        { name: 'workflowType', type: 'text' },
        { name: 'status', type: 'text' },
        { name: 'startTime', type: 'date' },
        { name: 'updateTime', type: 'date' },
        { name: 'endTime', type: 'date' },
        { name: 'reasonForIncompletion', type: 'text' }
      ]
    }
  },
  computed: mapState(['workflow', 'readOnly']),
  methods: {
    ...mapActions([
      'getWorkflow',
      'pauseWorkflow',
      'resumeWorkflow',
      'restartWorkflow',
      'retryWorkflow',
      'stopWorkflow',
      'archiveWorkflow',
      'removeWorkflow',
      'decideWorkflow'
    ])
  },
  created() {
    this.getWorkflow(this.workflowId)
  },
  watch: {
    workflowId: function() {
      this.getWorkflow(this.workflowId)
    }
  },
  components: {
    Fieldset,
    DataTable,
    DataList,
    RawJsonToggler,
    EmbedWorkflowDefinition
  }
}
</script>
